export class PostGetQuickCareVisitRequest {
    language: string = "";
    age: number | null = null;
    gender: string | null = "";
    maxDisplayCount: number = 3;
}